import React from 'react'
import { Button, ButtonProps } from './Button'

export const ButtonLink: React.SFC<ButtonProps> = props => (
  <Button type="link" loaderProps={{ white: false }} {...props} />
)
